import { matchPath, useLocation } from 'react-router';
import { unleashClient } from '../../../unleash/Unleash';
import { useIsFeatureEnabled } from '../../feature-enablement/featureEnablement';
import { DiscoveryCall, discoveryCallsList } from './discoveryCallsList';
import { DiscoveryCallSurvey } from './DiscoveryCallSurvey';
import { getDiscoveryCallsFlag } from './getDiscoveryCallsFlag';

const DiscoveryCallFeatureFlagCheck = ({
  discoveryCall,
}: {
  discoveryCall: DiscoveryCall;
}) => {
  const allFlags = unleashClient.getAllToggles();
  const flag = getDiscoveryCallsFlag(allFlags, discoveryCall.featureFlagSlug);

  const calendlyLink = flag?.calendlyLink;
  const isEnabled = !!(flag?.enabled && calendlyLink);

  return isEnabled ? (
    <DiscoveryCallSurvey
      discoveryCall={discoveryCall}
      calendlyLink={calendlyLink}
    />
  ) : null;
};

export const DiscoveryCalls = () => {
  const location = useLocation();
  const discoveryCallsEnabled = useIsFeatureEnabled('discovery-calls');

  const match = discoveryCallsList.find(({ triggerUrl }) =>
    matchPath(location.pathname, { path: triggerUrl, exact: true })
  );

  if (match && discoveryCallsEnabled) {
    return <DiscoveryCallFeatureFlagCheck discoveryCall={match} />;
  }

  return null;
};
